import { render, staticRenderFns } from "./layout-text.vue?vue&type=template&id=97a13d44&functional=true"
import script from "./layout-text.vue?vue&type=script&lang=js"
export * from "./layout-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports